import type { FC, SVGProps } from "react";

const ModuleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		{...props}
	>
		<rect
			x="2"
			y="2"
			width="12"
			height="12"
			rx="2"
			stroke="#737180"
			strokeWidth="1.5"
		/>
		<path d="M2 6h12" stroke="#737180" strokeWidth="1.5" />
	</svg>
);

export { ModuleIcon };
